import { Link } from 'react-router-dom';

const TypeTitle = ({ typeName, loading, breadcrumb = {} }) => {
    if (loading) return;

    return (
        <div className="relative z-[1] mb-10 md:mb-16 xl:mb-20 before:content-[''] before:absolute before:top-0 before:bottom-0 before:w-screen before:left-1/2 before:bg-quaternary before:-translate-x-1/2 before:-z-[1]">
            <div className="flex flex-col py-5 md:py-10">
                {breadcrumb.length ? (
                    <div className="flex flex-wrap max-sm:gap-y-0 max-sm:gap-x-3 gap-4">
                        {breadcrumb.map((item, index) => (
                            <div key={index} className="flex items-center">
                                <Link to={item.link} className="transition-all hover:opacity-75">
                                    <h4 className="text-sm md:text-base lg:text-lg text-white font-medium uppercase tracking-wider">
                                        {item.label}
                                    </h4>
                                </Link>
                                {index < breadcrumb.length - 1 && (
                                    <span className="w-1.5 sm:w-2 h-1.5 sm:h-2 border-t border-r border-white rotate-45 mt-0.5 ml-1.5 md:ml-2"></span>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <h4 className="text-sm md:text-base lg:text-lg text-white font-medium uppercase tracking-wider -mb-2">Produtos</h4>
                )}
                <h2 className="max-sm:text-2xl max-lg:text-4xl max-md:mt-2 lg:text-[44px] text-secondary font-semibold">{typeName}</h2>
            </div>
        </div>
    );
};

export default TypeTitle;
